import * as Sentry from "@sentry/react"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import * as React from "react"
import * as ReactDOM from "react-dom/client"

import App from "#components/App"

dayjs.extend(relativeTime)

import "./antdOverrides.css"
import "./index.css"

const isDevelopment = import.meta.env.DEV

if (!isDevelopment) {
  Sentry.init({
    dsn: "https://24ee1bf313c15dedec62433bdec8d263@o4509725609099264.ingest.us.sentry.io/4509725610344448",
    sendDefaultPii: true,
    beforeSend(event) {
      // Known Firebase SDK bug (github.com/firebase/firebase-js-sdk/issues/8250).
      // Non-fatal: the SDK self-recovers. Suppress to avoid drowning real errors.
      const msg = event.exception?.values?.[0]?.value ?? ""
      if (msg.includes("INTERNAL ASSERTION FAILED")) return null
      return event
    },
  })
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Playwright closes the page without running useEffect cleanup, so the
// Firestore emulator keeps those watches and the next test's users listen
// never gets an answer. The listen hooks already return unsubscribe from
// that cleanup; the e2e harness calls this so the unmount happens first.
if (isDevelopment) {
  const devWindow = globalThis as { __JARVIS_UNMOUNT__?: () => void }
  devWindow.__JARVIS_UNMOUNT__ = () => {
    root.unmount()
  }
}
